cockpitApp.directive('journey', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/detail/journey',
    controller: 'journeyController',
    controllerAs: 'journeyCtrl'
  };
});
